import { render, staticRenderFns } from "./asideLeft.vue?vue&type=template&id=64cfee2d&"
import script from "./asideLeft.vue?vue&type=script&lang=js&"
export * from "./asideLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports